import { chipCompoundVariants, chipDisabledVariants, chipElevatedVariants, chipEmphasisVariants, filterChipDefaultVariants, filterChipSlots, filterChipTypeVariants } from "../../variants/index.js";
import { tv } from "../../variants/tv.js";
const filterChipVariants = tv({
    slots: filterChipSlots,
    variants: {
        type: filterChipTypeVariants,
        disabled: chipDisabledVariants,
        elevated: chipElevatedVariants,
        emphasis: chipEmphasisVariants,
        hasHelperText: {
            true: {},
            false: {}
        },
        hasIconLeft: {
            true: {
                checkIconSlot: 'absolute'
            }
        },
        isChipRange: {
            true: {
                chipRangeSlot: 'w-full'
            },
            false: {}
        },
        selectedState: {
            true: {
                checkIconSlot: 'duration-medium',
                iconLeftSlot: 'scale-0 opacity-0 duration-medium',
                faviconSlot: 'w-0 scale-0 opacity-0 duration-medium'
            },
            false: {
                checkIconSlot: '!w-[0] scale-0 opacity-0 duration-short',
                iconLeftSlot: 'duration-short',
                faviconSlot: 'duration-short'
            }
        },
        hasCount: {
            true: {
                countSlot: 'scale-100 pr-1 opacity-100 transition-all duration-medium'
            },
            false: {
                countSlot: 'scale-0 pr-0 opacity-0 transition-all duration-short'
            }
        },
        showCheckIcon: {
            true: {},
            false: {}
        }
    },
    compoundVariants: chipCompoundVariants,
    defaultVariants: filterChipDefaultVariants
});
export { filterChipVariants };
